<template>
  <div style="position:relative;" v-if="'string_vertical'==item.type||'string'==item.type">
    <!-- 单行文本(支持预设内容选项) -->
    <el-input 
      v-model="properties[item.id]"
      type="textarea"
      class="form_input_1"
      :rows="1"
      @change="onChange"
      :placeholder="item.id">
    </el-input>

    <!-- 预设内容选项 -->
    <template v-if="item.enums && item.enums.length > 0">
      <i class="icon_1 el-icon-arrow-down" @click="showSuggestions"></i>
 
      <el-dialog
        top="0"
        :modal="false"
        :show-close="false"
        class="dialog_1"
        :visible.sync="dialogVisible">

        <div slot="title" style="height:0;margin-top:-10px;"> <!-- dialog no title --> </div>
        <span v-for="e in item.enums"
          :key="e.id"
          class="item_23"
          @click="onSelected_24(e, item)">{{e.id}}</span>
      </el-dialog>
    </template>
  </div>

  <!-- 多行文本 -->
  <el-input
    v-else-if="'textarea_vertical'==item.type"
    v-model="properties[item.id]"
    @change="onChange"
    type="textarea"
    :autosize="{minRows:2}"
    :placeholder="item.id"/>

  <!-- 整数 -->
  <el-input v-else-if="'long_vertical'==item.type||'long'==item.type"
    class="ticket_form_long"
    v-model="properties[item.id]"
    @input="onNumberInput"
    :placeholder="item.id" />

  <!-- 小数 -->
  <el-input-number v-else-if = "'double_vertical' == item.type || 'double' == item.type"
    v-model="properties[item.id]"
    :precision="2"
    @change="onChange"
    controls-position="right"
    :placeholder="item.id" />

  <!-- 是/否 -->
  <el-select v-else-if="'boolean_vertical' == item.type || 'boolean' == item.type"
    v-model="properties[item.id]"
    @change="onChange"
    clearable
    :placeholder="item.id">
    <el-option v-for="item in [{label:'是', value:'true'},{label:'否', value:'false'}]"
      :key="item.value"
      :label="item.label"
      :value="item.value"/>
  </el-select>

  <!-- 下拉选项 枚举 -->
  <el-select v-else-if="'enum_vertical' == item.type || 'enum' == item.type"
    v-model="properties[item.id]"
    clearable
    @change="onEnumChange"
    :placeholder="item.id">
    <el-option v-for="item in item.enums"
      :key="item.id"
      :label="item.name"
      :value="item.id"/>
  </el-select>

  <!-- 日期 -->
  <el-date-picker
    v-else-if="'budo_date_vertical' == item.type || 'budo_date' == item.type"
    v-model="properties[item.id]"
    @change="onChange"
    type="date"
    :placeholder="item.id"
    :value-format="item.expression"/>

  <!-- 时间(日期) -->
  <el-date-picker
    v-else-if="'datetime_vertical' == item.type || 'datetime' == item.type"
    type="datetime"
    v-model="properties[item.id]"
    @change="onChange"
    :placeholder="item.id" />

  <!-- 时间(日期) 范围-->
  <el-date-picker
    v-else-if="'datetime_range_vertical' == item.type || 'datetime_range' == item.type"
    v-model="properties[item.id]"
    @change="onChange"
    type="datetimerange"
    unlink-panels
    start-placeholder="开始"
    end-placeholder="结束"/>

  <!-- 日期范围 -->
  <el-date-picker
    v-else-if="'date_range_vertical' == item.type||'date_range' == item.type"
    v-model="properties[item.id]"
    @change="onChange"
    type="daterange"
    unlink-panels
    start-placeholder="开始"
    end-placeholder="结束"/>

  <!-- 选择月 -->
  <el-date-picker
    v-else-if="'month_vertical' == item.type||'month' == item.type"
    v-model="properties[item.id]"
    @change="onChange"
    type="month"
    placeholder="选择月"/>

  <!-- 选择周 -->
  <el-date-picker
    v-else-if="'week_vertical' == item.type||'week' == item.type"
    v-model="properties[item.id]"
    @change="onChange"
    type="week"
    format="yyyy-MM-dd 周"
    placeholder="选择周"/>

  <!--选择时间-->
  <el-time-picker
    v-else-if="'time_vertical' == item.type||'time' == item.type"
    v-model="properties[item.id]"
    @change="onChange"
    :placeholder="item.id"
    :value-format="item.expression"/>

  <!-- 选择时间范围 -->
  <el-time-picker
    v-else-if="'time_range_vertical' == item.type||'time_range' == item.type"
    is-range
    v-model="properties[item.id]"
    @change="onChange"
    :placeholder="item.id"
    :value-format="item.expression"/>

  <!-- 附件上传 -->
  <el-upload
    v-else-if="('upload_vertical' == item.type || 'upload' == item.type) && 'show'!=mode"
    multiple
    :data="uploadToken"
    action="//upload-z0.qiniup.com"
    :before-upload="beforeUpload"
    :on-success="uploadSuccess">
      <el-button>{{uploadButtonText}}</el-button>
  </el-upload>

  <!-- 附件展示图片 -->
  <div v-else-if="('upload_vertical' == item.type || 'upload' == item.type)
    && 'show' == mode
    && properties[item.id] && isImage(properties[item.id].url)">
    <el-popover placement="top-end" trigger="hover">
      <p><img :src="properties[item.id] ? properties[item.id].url : 'no-url-3'" class="img_upload_1" /></p>
      <a slot="reference"
        class="el-button"
        style="width:100%;"
        target="_blank"
        :href="properties[item.id] ? properties[item.id].url : 'no-url-1'">
          {{( !!properties[item.id] && !!properties[item.id].url ) ? '文件下载' : '未上传文件[2]'}}
          {{properties[item.id] ? properties[item.id].name : 'no-name-2'}}
      </a>
    </el-popover>
  </div>

  <!-- 附件展示非图片 -->
  <div v-else-if="('upload_vertical' == item.type || 'upload' == item.type) && 'show' == mode">
    <a slot="reference"
      class="el-button"
      style="width:100%;overflow:hidden;text-overflow:ellipsis;"
      target="_blank"
      :href="properties[item.id] ? properties[item.id].url : 'no-url-4'">
        {{( !!properties[item.id] && !!properties[item.id].url ) ? '文件下载' : '未上传文件[1]'}}
        {{properties[item.id] ? properties[item.id].name : 'no-name-5'}}
    </a>
  </div>

  <!-- 商家 -->
  <MerchantSearch
    v-else-if="'merchant_linkage' == item.type || 'merchant_vertical' == item.type || 'merchant' == item.type"
    v-model="properties[item.id]"
    :id="item.id"
    @change="onMerchantChange" />

  <LineSearch
    v-else-if="'line' == item.type"
    v-model="properties[item.id]"
    @change="onChange" />

  <!-- 订单 -->
  <MerchantOrderSearch
    v-else-if="'order_vertical' == item.type || 'order' == item.type || 'order_linkage' == item.type"
    v-model="properties[item.id]"
    @change="onOrderChange"/>

  <!-- 引用另一个工单的表单，新建 -->
  <div v-else-if="'ticket_form_vertical' == item.type && 'new'==mode">
    <TicketSearch
      v-model="properties[item.id]"
      @change="onChange"/>
  </div>

  <!-- 引用另一个工单的表单，展示 -->
  <div v-else-if="'ticket_form_vertical' == item.type && 'show' == mode"
    style="box-shadow:-1px -1px 15px 1px #F2F2E2;">
    <div style="text-align:center;">
      <span>----- -----</span>
      <span>引用工单</span>
      <a target="_blank"
        :href="'/ticket/t/' + properties[item.id]">
        #{{properties[item.id]}}
      </a>
      <TicketTitleByNo v-model="properties[item.id]"/>
      <span>----- -----</span>
    </div>

    <TicketTaskForm
      style="margin:0 -20px 0 -20px;"
      :ticketNo_2="properties[item.id]"
      mode_0='show' />
  </div>

  <!-- 关联订单同时展示商家店铺信息 -->
  <MerchantOrderSearchComplex
    v-else-if="'merchant_order_vertical_linkage' == item.type || 'merchant_order_vertical' == item.type"
    v-model="properties[item.id]"
    @change="onMerchantOrderChange"/>

  <!-- 选择一个人 -->
  <DealUserSearch 
    v-else-if="'ticket_user' == item.type || 'ticket_user_vertical' == item.type"
    v-model="properties[item.id]"
    :id="fromDialog == 'Yes' ? null : item.id"
    @change="onChange"/> 

  <!-- 选择多个人 -->
  <NoticeUserSearch 
    v-else-if="'multi_ticket_user' == item.type || 'multi_ticket_user_vertical' == item.type"
    v-model="properties[item.id]"
    @change="onChange"/>

  <!-- 富文本编辑器 -->
  <EditorSummernote
    v-else-if="'summernote_vertical' == item.type"
    minHeight = "100px"
    :id="'TicketTaskFormItem_' + item.id"
    v-model = "properties[item.id]"
    @change="onChange" />

  <div v-else-if="'divider_vertical' == item.type || 'divider' == item.type">
    <!-- 分割符 divider -->
  </div>

  <TicketFormDistrict v-else-if="'district_vertical'==item.type || 'district'==item.type"
    v-model="properties[item.id]" />

  <TicketFormRadio v-else-if="'radio_vertical'==item.type || 'radio'==item.type"
    v-model="properties[item.id]"
    :item="item"
    @change="onChange" />

  <TicketFormCheckbox v-else-if="'checkbox_vertical'==item.type || 'checkbox'==item.type"
    v-model="properties[item.id]"
    :item="item"
    @change="onChange" />

  <TicketFormSlider v-else-if="'slider_vertical'==item.type || 'slider'==item.type"
    v-model="properties[item.id]"
    :item="item"
    @change="onChange"/>

  <TicketFormRate v-else-if="'rate_vertical'==item.type || 'rate'==item.type"
    v-model="properties[item.id]"
    :item="item"
    @change="onChange"/>

  <TicketFormSwitch v-else-if="'switch_vertical'==item.type || 'switch'==item.type"
    :item="item"
    v-model="properties[item.id]" />

  <TicketFormAuth v-else-if="'auth_vertical'==item.type || 'auth'==item.type"
    :item="item"
    v-model="properties[item.id]"
    @change="onChange"/>

  <TicketFormShop v-else-if="'shop_vertical'==item.type || 'shop'==item.type"
    v-model="properties[item.id]"
    @change="onShopChange" />

  <TicketFormPhoneVerified v-else-if="'phone_verified_vertical' == item.type"
    ref="PhoneVerified"
    v-model="properties[item.id]"
    @change="onShopChange" />

  <WorkWeixinRelatedApproval v-else-if="'RelatedApproval' == item.type"/>

  <div v-else>其他表单类型 {{item}}</div>
</template>

<script>
export default {
  name: "TicketTaskFormItem",

  props: ['item', 'value', 'mode', 'fromDialog'],

  data() {
    return {
      dialogVisible : false,
      uploadButtonText : '点我上传文件',
      properties : {},
      uploadToken : null
    };
  },

  watch : {
    value() {
      // console.log('#279 watch value', this.value, this);

      this.properties = JSON.parse(JSON.stringify(this.value)); // copy 值
    }
  },

  mounted() {
    // console.log('#286 mounted value', this.value, this);

    this.properties = JSON.parse(JSON.stringify(this.value));

    if ( 'upload_vertical' == this.item.type || 'upload' == this.item.type ) {
      this.beforeUpload();
    }
  },

  methods : {
    validation() {
      if(!this.$refs.PhoneVerified) {
        return true;
      }

      return this.$refs.PhoneVerified.validation();
    },

    shadowRequired(value) {
      if(!this.$refs.PhoneVerified) {
        return;
      }

      return this.$refs.PhoneVerified.shadowRequired(value);
    },

    onEnumChange( _val ) {
      for( var i = 0; i < this.item.enums.length ; i++ ) {
        if ( _val == this.item.enums[i].id ) {
          var e = {
            fieldType : this.item.type,
            fieldName : this.item.id,
            fieldValue : this.properties[this.item.id],
            fieldLabel: this.item.name,
            enumlabel : this.item.enums[i].name
          };

          this.$emit('change', e, this.properties);
          this.$emit('input', this.properties);
          return;
        }
      }

      // 兜底
      this.onChange();
    },

    onOrderChange( _val ) {
      var e = {
        fieldType : this.item.type,
        fieldName : this.item.id,
        fieldValue : this.properties[this.item.id],
        fieldLabel: this.item.name,
        orderCode : _val.code
      };

      this.$emit('change', e, this.properties);
      this.$emit('input', this.properties);
    },

    onUserChange( _val, _id ) {
      var e = {
        fieldType : this.item.type,
        fieldName : this.item.id,
        fieldValue : _id,
        fieldLabel: this.item.name,

        user : _val /* 订单信息 */
      };

      this.$emit('change', e, this.properties);
      this.$emit('input', this.properties);
    },

    onMerchantOrderChange( _val ) {
      var e = {
        fieldType : this.item.type,
        fieldName : this.item.id,
        fieldValue : this.properties[this.item.id],
        fieldLabel: this.item.name,

        order : _val /* 订单信息 */
      };

      e[this.item.id + '_orderCode'] = _val.code;
      e[this.item.id + '_merchantCode'] = _val.merchantCode;
      e[this.item.id + '_merchantId'] = _val.merchantId;
      e[this.item.id + '_merchantName'] = _val.merchantName;
      e[this.item.id + '_shopId'] = _val.shopId;
      e[this.item.id + '_shopName'] = _val.shopName;

      this.$emit('change', e, this.properties);
      this.$emit('input', this.properties);
    },

    onMerchantChange( _val ) {
      if ( !!_val && !!_val['_type'] && 'merchant' == _val['_type'] ) {
        this.properties[_val['_id'] + '_name'] = _val.name;
        this.properties[_val['_id'] + '_code'] = _val.code;
      }

      var e = {
        fieldType : this.item.type,
        fieldName : this.item.id,
        fieldValue : this.properties[this.item.id],
        fieldLabel: this.item.name,
        merchantName : _val.name
      };

      this.$emit('change', e, this.properties);
      this.$emit('input', this.properties);
    },

    onShopChange( _val ) {
      if ( !!_val && !!_val['_type'] && 'shop' == _val['_type'] ) {
        this.properties[_val['_id'] + '_name'] = _val.name;
      }

      var e = {
        fieldType : this.item.type,
        fieldName : this.item.id,
        fieldValue : this.properties[this.item.id],
        fieldLabel: this.item.name,
        shopName : _val.name
      };

      this.$emit('change', e, this.properties);
      this.$emit('input', this.properties);
    },
    onNumberInput(val) {
      const clean = val.replace(/\D+/g, '');
      this.properties[this.item.id] = clean;
      this.onChange();
    },
    onChange() {
      // console.log('#378 TicketTaskFormItem onChange', this);

      this.$emit('change', {
        fieldType : this.item.type,
        fieldName : this.item.id,
        fieldValue : this.properties[this.item.id],
        fieldLabel: this.item.name
      } );

      this.$emit('input', this.properties);
    },

    //获取文件后缀名
    getSuffix(file) {
      if( !file ) {
        return "";
      }

      var fileName = file.name;
      var lastPlace = fileName.lastIndexOf("."), fileLength = fileName.length;
      return fileName.substring(lastPlace + 1, fileLength);
    },

    beforeUpload(file) {
      var _this = this;
      sdk.QiniuApi().qiniuToken({
        suffix : _this.getSuffix(file)
      }).then(resp => {
        _this.uploadToken = resp;
      });
    },

    uploadSuccess ( response, file, fileList) {
      this.uploadButtonText = "已上传 " + file.name + ", 点我重新上传"
      var uploadUrl = this.uploadToken.domain + '/' + response.key;

      this.properties[this.item.id] = {
        name : file.name,
        url : uploadUrl
      };

      this.$emit('input', this.properties);
    },

    showSuggestions(e) {
      this.dialogVisible = true;

      var a = $(e.target).prev()[0];
      var rect = a.getBoundingClientRect();

      $('.dialog_1 .el-dialog').css({
        "position" : "absolute",
        "left" : rect.x + "px",
        "top" : (rect.bottom + 15) + "px",
        "width" : rect.width + "px"
      });
    },

    onSelected_24(e, item) {
      this.properties[item.id] = e.id;

      this.onChange();

      this.dialogVisible = false;
    }
  }
}
</script>

<style>
.item_23 {
  display: block;
  padding: 5px 0 5px 5px;
}

.item_23:hover {
  background-color: #d8d8da;
}

.icon_1 {
  position: absolute;
  right: 20px;
  bottom: 10px;
}

.img_upload_1 {
  max-width: 50vw;
  max-height: 70vh;
}

.form_input_1 .el-textarea__inner {
  line-height: 28px;
  height: 15px;
  position: relative;
  margin-bottom: 0px;  
}

.el-textarea {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/ticket/TicketTaskFormItem.vue